import React from "react";
import "./Projects.css";

function Projects() {
  return (
    <div>
      <div className="title">
        <h1>Projects</h1>
      </div>
      <div className="row">
        <div className="projects">
          <div className="paragraph">
            <div class="project__name">
              <a
                href="https://whatsapp-clone-bbde8.firebaseapp.com/"
                target="__blank"
                className="important__link"
              >
                ChatRoom Web App
              </a>
            </div>
            <p>
              In this project, I built a WhatsApp inspired Chatroom Web-App in
              users can log in using their Google accounts in order to create or
              enter existing chatrooms and speak with members of these
              chatrooms. The project utilizes React on the frontend, Material-UI
              for the design aspect, Firebase for database and hosting and Redux
              for state management.
            </p>
            <div className="project__used1">
              <span className="project__used__item1">React</span>
              <span className="project__used__item1">Material UI</span>
              <span className="project__used__item1">Firebase</span>
            </div>
          </div>
        </div>
        <div className="projects">
          <div className="paragraph">
            <div class="project__name">
              <a
                href="https://covid-19-tracker-62f79.firebaseapp.com"
                target="__blank"
                className="important__link"
              >
                Covid-19 Tracker
              </a>
            </div>
            <p>
              In this project, I built a Covid-19 Tracker in which you can track
              daily Covid-19 metrics for cases, recoveries and deaths based on
              the Worldometer API along with their graphical and grographical
              visualization for the last 120 days. The project utilizes React on
              the frontend, Material-UI for the design aspect, Firebase for
              database and hosting and Redux for state management.
            </p>
            <div className="project__used1">
              <span className="project__used__item1">React</span>
              <span className="project__used__item1">Material UI</span>
              <span className="project__used__item1">Firebase</span>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="projects">
          <div className="paragraph">
            <div class="project__name">
              <a
                href="https://firemessenger-eec72.web.app/"
                target="__blank"
                className="important__link"
              >
                FireMessenger
              </a>
            </div>
            <p>
              In this project, I built a simple Facebook Messenger Clone in
              which users can chat with each other. The application is designed
              to be a open forum where anybody logging in the forum will be able
              to chat with anybody else. The project utilizes React on the
              frontend, Material-UI for the design aspect and Firebase for
              database and hosting.
            </p>
            <div className="project__used1">
              <span className="project__used__item1">React</span>
              <span className="project__used__item1">Material UI</span>
              <span className="project__used__item1">Firebase</span>
            </div>
          </div>
        </div>
        <div className="projects">
          <div className="paragraph">
            <div class="project__name">
              <a
                href="https://siddhantbhardwaj2018.github.io/FireGram/"
                target="__blank"
                className="important__link"
              >
                FireGram
              </a>
            </div>
            <p>
              In this project, I built a simple Instagram Clone where you can
              add pictures to the page from your local computer and it displays
              it immediately. The project utilizes React on the frontend, NodeJs
              on the backend, TailWindCSS for the design aspect , Firebase for
              database and GitHub Pages for the hosting.
            </p>
            <div className="project__used1">
              <span className="project__used__item1">React</span>
              <span className="project__used__item1">NodeJs</span>
              <span className="project__used__item1">Firebase</span>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="projects">
          <div className="paragraph">
            <div class="project__name">
              <a
                href="https://siddhantbhardwaj2018.github.io/Github-Jobs-App/"
                target="__blank"
                className="important__link"
              >
                GitHub Jobs App
              </a>
            </div>
            <p>
              In this project, I built a GitHub Job Search Portal. I used the
              Github Job Search API with the useState and useEffect Hooks in
              React. All you need to do is enter your language of choice, the
              location and full-time or part-time preference and the app returns
              a list of available job offers. This project was hosted on GitHub
              Pages.
            </p>
            <div className="project__used1">
              <span className="project__used__item1">React</span>
              <span className="project__used__item1">GitHub-Pages</span>
            </div>
          </div>
        </div>

        <div className="projects">
          <div className="paragraph">
            <div class="project__name">
              <a
                href="https://siddhantbhardwaj2018.github.io/Image-Search-Material-UI/"
                target="__blank"
                className="important__link"
              >
                Pixaby Image Finder
              </a>
            </div>
            <p>
              In this project, I built a Pixaby Image Finder which relays image
              results as you type into the search-bar. All you need to do is
              enter your search preference and the app returns a list of
              available images. Utilizing the Pixaby API,the project makes use
              of the GitHub Pages hosting service. The project uses React on the
              frontend and Material-UI for design purposes.
            </p>
            <div className="project__used1">
              <span className="project__used__item1">React</span>
              <span className="project__used__item1">Material-UI</span>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="projects">
          <div className="paragraph">
            <div class="project__name">
              <a
                href="https://siddhantbhardwaj2018.github.io/Expense-Tracker-App-React/"
                target="__blank"
                className="important__link"
              >
                Expense Tracker App
              </a>
            </div>
            <p>
              Keeping track of and managing your finances is something most
              college students take some time to learn. In keeping with this
              idea, I decided to build an expense tracker app in React that
              would allow the user to track his or her expenses.This was hosted
              on Github Pages.
            </p>
            <div className="project__used1">
              <span className="project__used__item1">React</span>
              <span className="project__used__item1">GitHub-Pages</span>
            </div>
          </div>
        </div>
        <div className="projects">
          <div className="paragraph">
            <div class="project__name">
              <a
                href="https://siddhantbhardwaj2018.github.io/Breaking-Bad-React/"
                target="__blank"
                className="important__link"
              >
                Breaking Bad App
              </a>
            </div>
            <p>
              I built a small React App which showcases all the chief characters
              from "Breaking Bad" series. You can search for a character by its
              name and it renders it as you type. The app made use of the
              Breaking Bad API and was hosted on Github Pages
            </p>
            <div className="project__used1">
              <span className="project__used__item1">React</span>
              <span className="project__used__item1">GitHub-Pages</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
